export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="count/count_minus">
<path id="Union" d="M24.1196 17.7942H7.88037V14.2056H24.1196V17.7942Z"/>
</g>
</svg>
